const COTACAO_TIPO = {
    REAL: { id: '1', descricao: 'Real' },
    ESTIMADA: { id: '2', descricao: 'Estimada' },
    PROJETADA: { id: '3', descricao: 'Projetada' },
    COPIA: { id: '4', descricao: 'Copia' },
    CALCULADA: { id: '5', descricao: 'Calculada' }
};

module.exports = COTACAO_TIPO;
